import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  expiry: number;
}

interface UserResponse {
  id: string;
  username: string;
  avatar: string;
}

interface SkinResponse {
  imageLink: string;
  skinName: string;
}

interface ProductsResponse {
  products: SkinResponse[];
}

interface AuthResponseReg {
  success: boolean;
  message: string;
  discordId: string;
  discordUsername: string;
  accessToken: string;
  refreshToken: string;
  expiry: string;
}

// Define the base URL for auth using the environment variable
const authBaseUrl = `${import.meta.env.VITE_API_BASE_URL}/api/v1/auth/`;

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: authBaseUrl, // Use the constructed base URL
    credentials: 'include',
  }),
  endpoints: (builder) => ({
    getDiscordLoginUrl: builder.mutation<{ url: string }, void>({
      query: () => ({
        url: "discord-login-url",
        method: "POST",
      }),
    }),
    discordCallback: builder.mutation<AuthResponse, string>({
      query: (code) => ({
        url: "discord-callback",
        method: "POST",
        body: { code },
      }),
    }),
    discordCallbackRegister: builder.mutation<AuthResponseReg, { code: string; state: string }>({
      query: (body) => ({
        url: "register/discord-callback",
        method: "POST",
        body,
      }),
    }),
    getUser: builder.mutation<UserResponse, string>({
      query: (access_token) => ({
        url: "user",
        method: "POST",
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      }),
    }),
    getFreeSkinsList: builder.mutation<ProductsResponse, void>({
      query: () => 'free-skins-list',
    }),
  }),
});

export const {
  useGetDiscordLoginUrlMutation,
  useDiscordCallbackMutation,
  useDiscordCallbackRegisterMutation,
  useGetUserMutation,
  useGetFreeSkinsListMutation,
} = authApi;
